import { render, staticRenderFns } from "./kotasyonformu.vue?vue&type=template&id=5b4de092&"
import script from "./kotasyonformu.vue?vue&type=script&lang=js&"
export * from "./kotasyonformu.vue?vue&type=script&lang=js&"
import style0 from "./kotasyonformu.vue?vue&type=style&index=0&id=5b4de092&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports